module.exports = __webpack_public_path__ + "img/cpp32.4f63403b.svg";